import { TextInput } from '@src/common/components/TextInput';
import { css } from '@src/common/styles/Styles';
import type { FieldValues, Path } from 'react-hook-form';
import type { FieldErrors } from 'react-hook-form/dist/types/errors';
import type { UseFormRegister } from 'react-hook-form/dist/types/form';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> {
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  fieldName: Path<T>;
  disabled?: boolean;
}

export const FormNumberInput = <T extends FieldValues>({
  register,
  errors,
  fieldName,
  disabled,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <TextInput
      className={fullWidth}
      {...register(fieldName, { valueAsNumber: true })}
      readOnly={disabled}
      label={t(`fields.${fieldName}`)}
      error={errors[fieldName] && t(`formErrors.${errors[fieldName]!.message}`)}
      type="number"
    />
  );
};

const fullWidth = css({
  flex: 1,
});
